import * as types from '../constants/actionTypes';

const initialState = {
  addresses: [],
  totalCount: 0,
  loading: false,
  error: null,
  editingAddress: null,
  creating: false,
  updating: false
};

const deliveryAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Delivery Addresses
    case types.FETCH_DELIVERY_ADDRESSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_DELIVERY_ADDRESSES_SUCCESS:
      return {
        ...state,
        loading: false,
        addresses: action.payload.addresses,
        totalCount: action.payload.totalCount,
        error: null
      };
    
    case types.FETCH_DELIVERY_ADDRESSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        addresses: [],
        totalCount: 0
      };

    // Create Delivery Address
    case types.CREATE_DELIVERY_ADDRESS_REQUEST:
      return {
        ...state,
        creating: true,
        error: null
      };
    
    case types.CREATE_DELIVERY_ADDRESS_SUCCESS:
      return {
        ...state,
        creating: false,
        addresses: [...state.addresses, action.payload.address],
        totalCount: state.totalCount + 1,
        error: null,
        editingAddress: null
      };
    
    case types.CREATE_DELIVERY_ADDRESS_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload.error
      };

    // Update Delivery Address
    case types.UPDATE_DELIVERY_ADDRESS_REQUEST:
      return {
        ...state,
        updating: true,
        error: null
      };
    
    case types.UPDATE_DELIVERY_ADDRESS_SUCCESS:
      return {
        ...state,
        updating: false,
        addresses: state.addresses.map(address => 
          address.id === action.payload.address.id 
            ? action.payload.address 
            : address
        ),
        error: null,
        editingAddress: null
      };
    
    case types.UPDATE_DELIVERY_ADDRESS_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload.error
      };
    // Set Editing Address  
    case types.SET_DELIVERY_ADDRESS_EDITING:
      return {
        ...state,
        editingAddress: action.payload.address
      };

    // Clear Editing Address
    case types.CLEAR_DELIVERY_ADDRESS_EDITING:
      return {
        ...state,
        editingAddress: null
      };

    default:
      return state;
  }
};

export default deliveryAddressReducer;